import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

const AssetOverlayOutlinedSvg = () => (
  <svg
    height="1em"
    width="1em"
    viewBox="0 0 200 200"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <g transform="translate(0,200) scale(0.1,-0.1)">
      <path
        d="M730 1710 l0 -270 115 0 115 0 0 -220 0 -220 -335 0 -335 0 0 -245 0
        -245 -135 0 -135 0 0 -245 0 -245 285 0 285 0 0 245 0 245 -110 0 -110 0 0
        200 0 200 295 0 295 0 0 -200 0 -200 -125 0 -125 0 0 -245 0 -245 285 0 285 0
        0 245 0 245 -120 0 -120 0 0 200 0 200 295 0 295 0 0 -200 0 -200 -110 0 -110
        0 0 -245 0 -245 285 0 285 0 0 245 0 245 -135 0 -135 0 0 245 0 245 -335 0
        -335 0 0 220 0 220 115 0 115 0 0 270 0 270 -270 0 -270 0 0 -270z
        m458 3 l2 -183 -190 0 -190 0 0 178 c0 98 3 182 7 186 4 3 88 5 187 4 l181 -3 3 -182z
        m-683 -1448 l0 -160 -200 0 -200 0 -3 150 c-1 82 0 155 2 162 4 9 53 11 203 10 l198 -2 0 -160z
        m695 -1 l0 -164 -200 0 -200 0 0 164 0 163 200 0 200 0 0 -163z
        m695 1 l0 -160 -200 0 -200 0 -3 150 c-1 82 -1 154 2 161 3 8 60 11 203 10 l198 -1 0 -160z"
      />
    </g>
  </svg>
);

export const AssetOverlayOutlined = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={AssetOverlayOutlinedSvg} {...props} />
);
